"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _loader = require("@tap-payments/loader");

var shortWhiteLoader = _interopRequireWildcard(require("../assets/white-loader.json"));

var shortBlackLoader = _interopRequireWildcard(require("../assets/black-loader.json"));

require("../assets/css/style.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TapLoader = /*#__PURE__*/function (_Component) {
  _inherits(TapLoader, _Component);

  var _super = _createSuper(TapLoader);

  function TapLoader(props) {
    var _this;

    _classCallCheck(this, TapLoader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      status: _this.props.status,
      type: _this.props.type,
      loader: shortWhiteLoader,
      second: true,
      duration: _this.props.duration
    });

    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  } // componentWillReceiveProps(nextProps) {
  //   this.load(nextProps);
  // }


  _createClass(TapLoader, [{
    key: "load",
    value: function load(value) {
      this.setState({
        status: value.status,
        type: value.type,
        loader: value.color === "white" ? shortWhiteLoader : shortBlackLoader,
        second: null,
        duration: value.duration
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        position: "relative",
        top: 50 - Math.floor(window.innerHeight / 100) % 100 + "%"
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "gosell-gateway-msg",
        style: {
          backgroundColor: // this.props.store.uIStore.modalMode == "popup"
          // ?
          "rgba(0, 0, 0, 0.6)" // : "#f0f1f2"

        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "gosell-gateway-msg-wrapper",
        style: window.innerWidth >= 440 ? style : {
          color: ""
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "60px",
          height: "60px",
          margin: "auto",
          display: this.state.status ? "block" : "none"
        }
      }, /*#__PURE__*/_react["default"].createElement(_loader.Loader, {
        toggleAnimation: this.state.status,
        animationData: this.state.loader,
        duration: this.state.type != "loader" ? this.state.status ? 4 : 3 : this.state.duration,
        secondData: this.state.second,
        secondDuration: 10
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: "gosell-gateway-msg-title",
        style: {
          color: this.props.color === "white" ? this.props.color : "#4b4847"
        }
      }, this.props.title), /*#__PURE__*/_react["default"].createElement("p", {
        className: "gosell-gateway-msg-desc",
        style: {
          color: this.props.color === "white" ? "#a4a5a7" : "#797777"
        }
      }, this.props.desc), /*#__PURE__*/_react["default"].createElement("br", null)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.status !== prevState.status) {
        return {
          status: nextProps.status,
          type: nextProps.type,
          loader: nextProps.color === "white" ? shortWhiteLoader : shortBlackLoader,
          second: null,
          duration: nextProps.duration
        };
      }

      return null;
    }
  }]);

  return TapLoader;
}(_react.Component);

var _default = TapLoader;
exports["default"] = _default;